import React from 'react';

import { Column, Input, Table, TabPanel, Tabs } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import { store } from '../../../store/Store';
import LeadsEditableFieldType from '../../../consts/LeadsEditableFieldType';
import { LeadsManageAction } from '../../../actions/LeadsManageAction';
import { Tags } from '../../../consts/Tags';
import CallRecordPage from './CallRecordPage';

import { isSubAccount } from '../../../consts/multiAccountConfig';
import LeadsPushRecordTab from './LeadsPushRecordTab';
import LeadsLogTab from './LeadsLogTab';

import { isLeadsRole, hasPrivilege } from '../../../utils/routes';

export default class LeadsFollowRecordTab extends React.Component {
  componentDidMount() {
    this.refresh();
    console.log(this.props,'-09-09-9-9-9-09-09')
  }

  refresh() {
    RPCFactory.leadsManage
      .getLeadsFollowInfo(window.pageProps.uid, this.props.leadsId)
      .done((data) => {
        this.setState({ records: data.entities });
      })
      .fail((ret, msg) => {
        alert(`请求跟进记录错误，msg:${msg}`);
      });

    RPCFactory.leadsManage
      .getLeadsCallRecordInfo(window.pageProps.uid, this.props.leadsId)
      .done((data) => {
        this.setState({ phoneRecords: data.entities });
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  }

  /**
   *
   * @param props
   * this.props.leadsId
   */
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      record: '',
      value: 0,
      phoneRecords: [],
      detailMessage: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, value) {
    this.setState({
      value,
    });
  }

  onEditRecord = (event) => {
    this.setState({ record: event.target.value });
  };

  onSubmit = (event) => {
    const text = this.state.record;
    if (!text) {
      alert('跟进记录不能为空');
      return;
    }

    RPCFactory.leadsManage
      .insertLeadsFollowRecord(window.pageProps.uid, this.props.leadsId, text)
      .done((data) => {
        this.setState({ record: '' });
        this.refresh();
        store.dispatch({
          type: LeadsManageAction.UPDATE_SINGLE_LEADS,
          updateType: LeadsEditableFieldType.FOLLOW,
          targetValue: text,
          targetLeadsId: this.props.leadsId,
        });
      })
      .fail((ret, msg) => {
        alert(`插入失败，msg:${msg}`);
      });
  };

  renderUserTel = (type, name, value, data) => {
    if (type == 'head') return value;
    return value.replace('+86', '');
  };

  renderConsumerHotline = (type, name, value, data) => {
    if (type == 'head') return value;
    const label = value ? value.replace('+86', '') : '';
    if (data.callType && data.callType == 1) {
      return (
        <div>
          {label}
          <i className="spaui-icon icon-robot"></i>
        </div>
      );
    }
    return label;
  };

  getTouchTagNum = (data) => {
    // callTagsStatus 对应含义详见Tags.leadsTouchTag
    let callTagStatus = 0;
    const duration = parseInt(data.duration);
    // duration是0, 未接通。对未接通状态进行判断
    if (duration == 0) {
      // 判断在呼出情况下，失败原因为4或7，则判断为无效号码（4为停机，7为空号)
      if ((data.callFailReason == 4 || data.callFailReason == 7) && data.callDirection == '呼出') {
        // 判断为“未接通-无效号码”
        callTagStatus = 4;
      } else {
        // 判断为“未接通-其他”
        callTagStatus = 1;
      }
    } else if (duration < 10) {
      callTagStatus = 2;
    } else {
      callTagStatus = 3;
    }
    return callTagStatus;
  };

  renderCallStatus = (type, name, value, data) => {
    if (type == 'head') return value;

    return Tags.leadsTouchTag[this.getTouchTagNum(data)];
  };

  renderRecordUrlTimeLimited = (type, name, value, data) => {
    if (type == 'head') return value;

    if ([2, 3].indexOf(this.getTouchTagNum(data)) < 0) {
      // 只有未回应和已回应才显示调听按钮
      return '';
    }

    return (
      <a href="javascript:void(0)" onClick={this.getRecord.bind(this, data)}>
        调听
      </a>
    );
  };

  getRecord = (record) => {
    RPCFactory.leadsManage
      .getLeadsCallRecordUrl(record.leadsId, record.id)
      .done((data) => {
        window.open(data, '_blank');
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  getRecordAddPermission = () => {
    const tab = this.props.leadsTab;
    switch (tab) {
      case 'pool':
        return hasPrivilege('LEADS_PUBLIC_POOL_EDIT_DETAIL');
      case 'self':
        return hasPrivilege('LEADS_SELF_EDIT_DETAIL');
      case 'group':
        return hasPrivilege('LEADS_GROUP_EDIT_DETAIL');
      case 'company':
        return hasPrivilege('LEADS_COMPANY_EDIT_DETAIL');
      default:
        return false;
    }
  };

  render() {
    const recordElement = [];
    const canAddRecord = !isSubAccount() && this.getRecordAddPermission();
    const { value, records } = this.state;

    if (records) {
      records.forEach((e) => {
        recordElement.push(
          <li>
            <div className="nametime">
              <p>{e.operatorName}</p>
              <p className="time">{e.createdTime}</p>
            </div>
            <div className="dess">
              <p>{e.detail}</p>
            </div>
            <div className="sg"></div>
            <div className="sg-line"></div>
          </li>,
        );
      });
    }

    return (
      <Tabs onChange={this.handleChange} value={value} needSlider={false}>
        <TabPanel tab="跟进记录" name={0}>
          <div className="follow-records">
            {canAddRecord && (
              <div className="form-inline">
                <Input value={this.state.record} onChange={this.onEditRecord} placeholder="添加跟进记录" />
                <button onClick={this.onSubmit} className="spaui-button spaui-button-default">
                  添加
                </button>
              </div>
            )}
            <ul className="records">{recordElement}</ul>
          </div>
        </TabPanel>
        <TabPanel tab="通话记录" name="1">
          <div className="follow-calling">
            <div className="datalist">
              <Table data={this.state.phoneRecords}>
                <Column name="createdTime">通话时间</Column>
                <Column name="userTel" render={this.renderUserTel}>
                  用户
                </Column>
                <Column name="consumerHotline" render={this.renderConsumerHotline}>
                  客服
                </Column>
                <Column name="middleNumber">
                  中间号
                </Column>
                <Column name="callStatus" render={this.renderCallStatus}>
                  接通状态
                </Column>
                <Column name="durationFormat">通话时长</Column>
                {/* <Column name="callMode">呼叫方式</Column> */}
                <Column name="callDirection">呼叫类型</Column>
                <Column name="callDurationFormat">呼叫时长</Column>
                <Column name="callStatus" render={this.renderRecordUrlTimeLimited}>
                  通话录音
                </Column>
              </Table>
            </div>
          </div>
        </TabPanel>
        <TabPanel tab="线索操作日志" name="4">
          <LeadsLogTab detailAdvertiserId={this.props.detailAdvertiserId} leadsId={this.props.leadsId} />
        </TabPanel>
        {(this.props.actionSubType === 6 || this.props.leadsSubType === 10003) && (
          <TabPanel tab="会话记录" name="2">
            <CallRecordPage leadsId={this.props.leadsId}></CallRecordPage>
          </TabPanel>
        )}
        {window.pageProps.privileges.includes(PrivilegeCode.LEADS_PUSH_RECORD_VIEW.getCode()) && (
          <TabPanel tab="线索推送记录" name={3}>
            <LeadsPushRecordTab leadsId={this.props.leadsId} />
          </TabPanel>
        )}
      </Tabs>
    );
  }
}
